import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsAddSubscription = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
